import { render, staticRenderFns } from "./SubscriptionStop.vue?vue&type=template&id=2216d1f8&scoped=true&"
import script from "./SubscriptionStop.vue?vue&type=script&lang=js&"
export * from "./SubscriptionStop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2216d1f8",
  null
  
)

export default component.exports